export default __webpack_public_path__ + "static/media/matterbase-word.2595c183.svg";